module.exports = "/public/assets/error-img.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/img/error-img.jpg
// module id = 1489
// module chunks = 3